/* eslint-disable camelcase */
import z from "zod";

export const schema = z.object({
    id: z.string(),
    questions: z.array(z.discriminatedUnion(
        "type",
        [
            z.object({
                type: z.literal("html"),
                id: z.string(),
                tooltip: z.string().optional(),
                class: z.unknown(),
                dependsOn: z.literal("true"),
                content: z.array(z.object({
                    id: z.string().optional(),
                    type: z.string(),
                    class: z.string().default(""),
                    string: z.string().default(""),
                }).strict()),
                mdependsOn: z.string().optional(),
            }),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                question: z.string(),
                alias: z.string().optional(),
                type: z.literal("dateRow"),
                minAge: z.string().optional(),
                maxAge: z.string().optional(),
                inp_type: z.array(z.string()),
                validate: z.string(),
                class: z.unknown(),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                type: z.literal("readings"),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                type: z.literal("medication"),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                type: z.literal("previousMedication"),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                type: z.literal("input"),
                alias: z.string().optional(),
                question: z.string().optional(),
                class: z.unknown(),
                validate: z.string(),
                mdependsOn: z.string().optional(),
                inp_type: z.literal("text").or(z.literal("email"))
                    .or(z.literal("number")).or(z.literal("currency")).optional(),
                placeholder: z.string().optional(),
                validateSpecial: z.array(z.tuple([z.string(), z.string(), z.string(), z.string()])).optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                type: z.literal("select"),
                selectType: z.literal("deprange").or(z.literal("range")).optional(),
                alias: z.string(),
                class: z.unknown(),
                validate: z.string(),
                placeholder: z.string().optional(),
                options: z.array(z.tuple([z.string(), z.string()])).optional(),
                from: z.number().optional(),
                to: z.number().optional(),
                question: z.string().optional(),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                tooltip: z.string().optional(),
                isOptional: z.string().optional(),
                type: z.literal("radio"),
                alias: z.string().optional(),
                question: z.string(),
                class: z.unknown(),
                validate: z.string(),
                options: z.array(z.tuple([z.string(), z.string(), z.string(), z.string()])),
                mdependsOn: z.string().optional(),
            }).strict(),
            z.object({
                id: z.string(),
                mdependsOn: z.string().optional(),
                alias: z.string().optional(),
                type: z.literal("validation"),
                validate: z.string(),
                content: z.array(z.object({
                    id: z.string().optional(),
                    type: z.string(),
                    class: z.string().default(""),
                    string: z.string().default(""),
                }).strict()),
            }).strict(),
        ],
    )),
}).strict();

export const parseSchema = (data: unknown) => schema.parse(data);

export type SchemaType = z.infer<typeof schema>;
export type SchemaQuestion = SchemaType["questions"][0];
export type SchemaFormQuestion = Extract<SchemaQuestion,
    { type: "input" | "dateRow" | "radio" | "select" | "validation" }>;
export type SchemaHtmlQuestion = Extract<SchemaQuestion, { type: "html" }>;
